<template>
  <div class="overlay" v-if="user">
    <div class="page-lock">
      <div class="page-logo">
        <a class="brand" href="/">
          <img src="/static/pages/img/logo.png" alt="logo">
        </a>
      </div>
      <div class="alert alert-danger" v-show="loginError != ''">
        <button class="close" data-close="alert"></button>
        <span>{{ loginError }}</span>
      </div>
      <div class="page-body">
        <div class="lock-head"> Locked </div>
        <div class="lock-body">
          <div class="lock-cont">
            <div class="lock-item">
              <div class="pull-left lock-avatar-block">
                <avatar v-bind:username="user.first_name" v-bind:src="user.avatar" :size="140" :rounded="true" color="#d09f23" backgroundColor="#eef1f5"></avatar>
              </div>
            </div>
            <div class="lock-item lock-item-full">
              <form class="lock-form pull-left" v-on:submit.prevent="onSubmit">
                <h4>{{ user.first_name }} {{ user.last_name }}</h4>
                <div class="form-group">
                  <input class="form-control placeholder-no-fix" type="password" autocomplete="off" placeholder="Password" name="password" v-model="password"> </div>
                <div class="form-actions">
                  <button type="submit" class="btn btn-warning uppercase mt-ladda-btn ladda-button" data-style="expand-left">
                    <span class="ladda-label">Sign In</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="lock-bottom">
          <router-link to="/login" style="color:#d09f23!important">Not {{ user.first_name }} {{ user.last_name }}?</router-link>
        </div>
      </div>
      <div class="page-footer-custom">© {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved. </div>
    </div>
  </div>
</template>
<script>
import Avatar from '@/components/menu/Avatar';
import {mapActions, mapGetters} from 'vuex';
export default {

  data() {
    return {
      password: ''
    }
  },

  components: {
    Avatar
  },
  computed: {
    ...mapGetters({
      loginError: 'getLoginError',
      user: 'getUser'
    }),
    getCurrentYear:function(){
      const d = new Date();
      let year = d.getFullYear();
      return year
    }
  },
  methods: {
    ...mapActions({
      login: 'LOGIN_ACTION'
    }),
    onSubmit() {
      const context = Ladda.create(document.querySelector('.ladda-button'));
      var credentials = {
        email: this.user.email,
        password: this.password
      };
      this.login({credentials, context, notify: false});
      this.password = ''
    }

  },

  beforeMount() {
    if(this.user == null) {
      this.$router.push('/login');
    }
  }

}
</script>
<style scoped>
.overlay {
  background-color: #ffffff;
  min-height: 100vh;
  min-width: 100vw;
  position: absolute;
}
.brand img {
  width:100%;
}
</style>



// WEBPACK FOOTER //
// LockScreen.vue?2c01cbe5